module.exports = __webpack_public_path__ + "static/media/puzzle0104.20fbd745.jpg";